import SeloColaboracao from 'assets/img/comportamento/selo-colaboracao-1S2026.png';

const CARTAO = 'absolute box-border blur-[1px]';

const BARRA = 'block rounded-full';

export default function ComposicaoFundo() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute left-1/2 top-1/2 h-[660px] w-[1300px] -translate-x-1/2 -translate-y-1/2">
        <span
          className="absolute left-1/2 top-1/2 h-[300px] w-[300px] rounded-full bg-brand-yellow"
          style={{ margin: '-330px 0 0 -400px' }}
        />
        <span
          className="absolute left-1/2 top-1/2 h-[190px] w-[190px] rounded-full bg-brand-cyan-light"
          style={{ margin: '180px 0 0 210px' }}
        />

        <div
          className={`${CARTAO} left-0 top-[4%] flex w-[300px] items-center gap-3.5 rounded-2xl bg-brand-white px-[18px] py-4 shadow-[0_12px_26px_rgba(0,45,75,0.14)]`}
          style={{ transform: 'rotate(-6deg)' }}
        >
          <span className="h-[42px] w-[42px] shrink-0 rounded-full bg-brand-pink-light" />
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <span className={`${BARRA} h-[9px] w-[86%] bg-[#E3E6EB]`} />
            <span className={`${BARRA} h-[7px] w-[60%] bg-[#EDEFF3]`} />
          </div>
          <span className="shrink-0 rounded-full bg-brand-yellow px-3 py-[7px] font-display text-xs font-extrabold text-brand-blue">
            +300
          </span>
        </div>

        <div
          className={`${CARTAO} bottom-[2%] left-3.5 flex w-[320px] flex-col gap-3 rounded-[20px] bg-brand-green-light px-[22px] py-5 shadow-[0_12px_26px_rgba(0,45,75,0.12)]`}
          style={{ transform: 'rotate(4.5deg)' }}
        >
          <span className={`${BARRA} h-2.5 w-[58%] bg-[rgba(0,45,75,0.2)]`} />
          <span className={`${BARRA} h-[7px] w-[84%] bg-white/80`} />
          <div className="flex flex-col gap-2.5 rounded-xl bg-brand-white px-[15px] py-[13px]">
            <span className={`${BARRA} h-[7px] w-[46%] bg-[#E3E6EB]`} />
            <span className={`${BARRA} h-2 w-full overflow-hidden bg-[#EDEFF3]`}>
              <span className={`${BARRA} h-2 w-[38%] bg-brand-blue`} />
            </span>
          </div>
        </div>

        <div
          className={`${CARTAO} right-0 top-[2%] w-[288px] rounded-[20px] bg-brand-yellow-light px-[22px] py-5 shadow-[0_12px_26px_rgba(0,45,75,0.12)]`}
          style={{ transform: 'rotate(5.5deg)' }}
        >
          <div className="flex flex-col gap-3 rounded-xl bg-brand-white px-[17px] py-[15px]">
            <span className={`${BARRA} h-[9px] w-[66%] bg-[#E3E6EB]`} />
            {['#VALEU', '#MANDOUBEM', '#UAU'].map(marca => (
              <div key={marca} className="flex items-center gap-2">
                <span className="font-display text-[11px] font-bold text-content-soft">{marca}</span>
                <span className={`${BARRA} ml-auto h-1.5 w-[54px] bg-[#EDEFF3]`} />
              </div>
            ))}
          </div>
        </div>

        <div
          className={`${CARTAO} bottom-[6%] right-6 flex w-[262px] items-center gap-3.5 rounded-2xl bg-brand-white px-5 py-[18px] shadow-[0_12px_26px_rgba(0,45,75,0.14)]`}
          style={{ transform: 'rotate(-4deg)' }}
        >
          <img src={SeloColaboracao} alt="" className="block h-[54px] w-[54px] shrink-0 object-contain" />
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <span className={`${BARRA} h-[9px] w-[80%] bg-[#E3E6EB]`} />
            <span className={`${BARRA} h-[7px] w-[50%] bg-[#EDEFF3]`} />
          </div>
        </div>
      </div>
    </div>
  );
}
